import {Card} from "@/components/card/Card.tsx";
import {MonitoringServiceChoices} from "@/lib/types/checks.ts";
import {MonitoringServer} from "@/lib/types/monitoring.ts";
import {LHRScreenshot} from "@/pages/pagespeed/report/LHRScreenshot.tsx";
import {PSChecksParamBlock} from "@/pages/pagespeed/report/PSChecksParamBlock.tsx";
import {PSReportMainActions} from "@/pages/pagespeed/report/PSReportMainActions.tsx";
import {UptimeCWVBlock} from "@/pages/pagespeed/report/UptimeCWVBlock.tsx";
import {UptimeGradeBlock} from "@/pages/pagespeed/report/UptimeGradeBlock.tsx";
import {PagespeedLHR, PSReportOptions} from "@/pages/pagespeed/types.ts";

interface PSReportMainProps {
  lhr: PagespeedLHR;
  id: number;
  performanceGrade?: string;
  mspChoices: MonitoringServiceChoices;
  monitoringServer?: MonitoringServer;
  options?: PSReportOptions;
}
export const PSReportMain = ({id, lhr, mspChoices, performanceGrade, monitoringServer, options}: PSReportMainProps) => (
  <Card variant="white" key="main" className="row">
    <div className="col-md-6">
      <PSChecksParamBlock lhr={lhr} mspChoices={mspChoices} monitoringServer={monitoringServer} options={options} />
      <div className="row">
        <div className="col-md-6">
          <UptimeGradeBlock categories={lhr.categories} performanceGrade={performanceGrade ?? "-"} />
        </div>
        <div className="col-md-6">
          <UptimeCWVBlock audits={lhr.audits} />
        </div>
      </div>
      <PSReportMainActions className="mt-2" id={id} />
    </div>
    <div className="col-md-6">
      <LHRScreenshot audits={lhr.audits} fullPageScreenshot={lhr.fullPageScreenshot} />
    </div>
  </Card>
);
